/**
 * Created by Ning Jiang on 11/12/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {StageEvent} from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IdleAnimationController} from "@nolimitcity/slot-game/bin/game/idleanimation/IdleAnimationController";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {DeadwoodGameConfig} from "../DeadwoodGameConfig";
import {TweenLite} from "gsap";

export class TumbleWeedIdleAnimation extends IdleAnimationController {

    private _twSprite:PIXI.Sprite;
    private _spine:PIXI.spine.Spine |undefined;

    constructor() {
        super({
            startTime : 3,
            minInterval : 1,
            maxInterval : 25
        });
    }

    protected addEventListeners():void {
        super.addEventListeners();
        EventHandler.addEventListener(this, StageEvent.STAGE_RESIZED, (event:GameEvent) => this.onStageResized(event.params[0]));
    }

    private onStageResized(resizeData:IResizeData):void {
        this.relocate();
    }

    private relocate():void {
        if(!this._twSprite) {
            return;
        }
        this._twSprite.position.set(GameConfig.instance.GAME_WIDTH * 0.5, StageManager.orientation === Orientation.PORTRAIT ? Math.ceil(NolimitApplication.screenBounds.height - this._twSprite.parent.y / this._twSprite.parent.scale.y) - GameConfig.instance.GAME_HEIGHT * 0.5 : GameConfig.instance.GAME_HEIGHT * 0.5);
    }

    protected onGameDataParsed(data:ParsedGameData):void {
    }

    protected hasWin():boolean {
        return false;
    }

    protected playIdleAnimation():void {
        if(!this._twSprite) {
            this._twSprite = new PIXI.Sprite();
            this._twSprite.anchor.set(0.5);
            StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.BACKGROUND_IDLE.name).addChild(this._twSprite);
            this.relocate();
        }

        if (this._spine){
            return;
        }

        const twSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("tumbleWeed"));
        twSpine.autoUpdate = true;
        twSpine.state.addListener({complete : () => TweenLite.to(this, 0.5, {onComplete : () => this.recycleSpine(twSpine)})});
        twSpine.state.clearTrack(0);
        twSpine.skeleton.setToSetupPose();
        twSpine.state.setAnimation(0, `animation${Math.floor(Math.random() * 3)}`, false);
        this._twSprite.addChild(twSpine);
        this._spine = twSpine;
    }

    private recycleSpine(twSpine:PIXI.spine.Spine):void {
        twSpine.visible = false;
        twSpine.state.setEmptyAnimation(0, 0);
        this._twSprite.removeChild(twSpine);
        twSpine.destroy();
        this._spine = undefined;
    }
}